<template>
  <div class="conditions-container">
    <EnPage v-if="lang === 'en'" />
    <KrPage v-else />
  </div>
</template>

<script>
import KrPage from './KrPage.vue'
import EnPage from './EnPage.vue'

export default {
  components: {
    KrPage,
    EnPage
  },
  mounted(){
    console.log('112313')
  },
  computed: {
    lang() {
      return this.$route.query.lang
    }
  }
}
</script>

<style lang='scss' scoped>
.conditions-container {
  border-top: 1px solid #ECECEC;
  height: 100vh;
  overflow-y: auto;
}
</style>